import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import AdHocPoolStageCreator from '@/components/tickets/AdHocPoolStageCreator.vue'
import { computed, ref } from 'vue'
import { useEligibleServiceProvidersQuery } from '../../api/pools'

export type AdHocPoolStage = {
  stageNumber: number
  recipients: string[]
}
export type AdHocPool = {
  stages: AdHocPoolStage[]
  delay: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdHocPoolCreator',
  props: {
    adHocPool: null,
    resourceTypeId: null,
    hubId: null
  },
  emits: ["update-stage", "remove-stage", "add-stage", "update-delay"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update-stage', stage: AdHocPoolStage)
  (e: 'remove-stage', stageNumber: number)
  (e: 'add-stage', stageNumber: number)
  (e: 'update-delay', delay: string)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  adHocPool: AdHocPool
  resourceTypeId: number
  hubId: string
}





const { data: eligibleServiceProviders } = useEligibleServiceProvidersQuery(
  ref(props.hubId),
  ref(props.resourceTypeId)
)
const selectableServiceProviders = (stageNumber) => {
  if (eligibleServiceProviders && eligibleServiceProviders.value) {
    const selectedServiceProviderIds = props.adHocPool.stages
      .filter((s) => s.stageNumber !== stageNumber)
      .map((s) => s.recipients)
      .flat()

    return eligibleServiceProviders.value.filter(
      (sp) => !selectedServiceProviderIds.includes(sp.id)
    )
  } else {
    return []
  }
}

const stageCount = computed<number>(() => {
  return props.adHocPool.stages.length
})

const disableAddStageButton = computed<boolean>(() => {
  const totalRecipients = props.adHocPool.stages.reduce(
    (acc, stage) => acc + stage.recipients.length,
    0
  )
  return eligibleServiceProviders?.value?.length === totalRecipients
})

const updateDelay = (value: string) => {
  emits('update-delay', value)
}
const addStage = () => {
  emits('add-stage', stageCount.value + 1)
}
const updateStage = (value: AdHocPoolStage) => {
  emits('update-stage', value)
}
const removeStage = (stageNumber) => {
  emits('remove-stage', stageNumber)
}

return { __sfc: true,emits, props, eligibleServiceProviders, selectableServiceProviders, stageCount, disableAddStageButton, updateDelay, addStage, updateStage, removeStage, VsButton, VsWrapper, VsTextInput, AdHocPoolStageCreator }
}

})